import React, { useState } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import IconButton from '@mui/material/IconButton'
import LoadingButton from '@mui/lab/LoadingButton'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'

interface SaveVersionModalProps {
    open: boolean
    onClose: () => void
    onSave: (note: string) => Promise<void>
    isLoading: boolean
    columnTitle: string
}

const SaveVersionModal = ({ open, onClose, onSave, isLoading, columnTitle }: SaveVersionModalProps) => {
    const [note, setNote] = useState('')

    const handleSave = async () => {
        await onSave(note)
        setNote('')
    }

    const handleClose = () => {
        if (isLoading) return
        setNote('')
        onClose()
    }

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ pb: 1 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="18x600">Save Version</Typography>
                    <IconButton
                        aria-label="close"
                        disabled={isLoading}
                        onClick={handleClose}
                        sx={{ color: 'figma.grayscale.tier1' }}
                    >
                        <HighlightOffIcon />
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Stack gap={2}>
                    <Typography variant="14x400" color="figma.grayscale.textHier2">
                        Save a version of <strong>{columnTitle}</strong>
                    </Typography>
                    <TextField
                        label="Note (optional)"
                        placeholder="Enter a note for this version"
                        fullWidth
                        multiline
                        rows={3}
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                        disabled={isLoading}
                        autoFocus
                    />
                </Stack>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <LoadingButton
                    loading={isLoading}
                    variant="contained"
                    onClick={handleSave}
                    sx={{
                        borderRadius: '14px',
                        px: 3,
                    }}
                >
                    Save
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}

export default SaveVersionModal
